<span class="block">
<!--  <div class="text">-->
    <!--      <h1>Disclaimer</h1>-->
    <!--&lt;!&ndash;      <p>&ndash;&gt;-->
    <!--&lt;!&ndash;Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore&ndash;&gt;-->
    <!--&lt;!&ndash;          magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita&ndash;&gt;-->
    <!--&lt;!&ndash;          kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,&ndash;&gt;-->
    <!--&lt;!&ndash;          consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,&ndash;&gt;-->
    <!--&lt;!&ndash;          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,&ndash;&gt;-->
    <!--&lt;!&ndash;          no sea takimata sanctus est Lorem ipsum dolor sit amet.&ndash;&gt;-->
    <!--&lt;!&ndash;      </p>&ndash;&gt;-->
    <!--      <h1>-->
    <!--          About-->
    <!--      </h1>-->
    <!--&lt;!&ndash;      <p>&ndash;&gt;-->
    <!--&lt;!&ndash;Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore&ndash;&gt;-->
    <!--&lt;!&ndash;          magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita&ndash;&gt;-->
    <!--&lt;!&ndash;          kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,&ndash;&gt;-->
    <!--&lt;!&ndash;          consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,&ndash;&gt;-->
    <!--&lt;!&ndash;          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,&ndash;&gt;-->
    <!--&lt;!&ndash;          no sea takimata sanctus est Lorem ipsum dolor sit amet.&ndash;&gt;-->
    <!--&lt;!&ndash;      </p>&ndash;&gt;-->
    <!--  </div>-->
</span>
